import type { ThemeConfig } from '@/types/theme'
export const themeConfig: ThemeConfig = {
  logoImageURL: import.meta.env.VITE_LOGO_IMAGE_URL || '/assets/default-logo.png',
  bannerImageURL: import.meta.env.VITE_BANNER_IMAGE_URL || '/assets/default-banner.jpg',
  defaultTheme: 'light'
}